export enum PayPlatform {
    wechat = 1,
    alipay = 2,
    ios = 3,
}

export enum PayStatus {
    paying = 0b1,
    paid = 0b10,
    fail = 0b100,
    refunding = 0b1000,
    refunded = 0b10000,
    refundedFail = 0b100000,
    exception = 0b1000000,
    closed = 0b10000000,
}

export type IPayOrder = {
    /**
     * 订单总表
     */
    id: number;
    /**
     * 支付用户
     */
    user_id: number;
    /**
     * 支付平台：1：微信，2：支付宝，3：苹果
     */
    pay_platform: PayPlatform;
    /**
     * 对应订单详情表的id
     */
    detail_order_id: number;
    /**
     * 对应平台请求时的配置信息id
     */
    config_id?: number;
    /**
     * 对应平台的商家订单号
     */
    out_trade_no?: string;
    /**
     * 订单状态（二进制状态码），1：待付款，2：已付款，4：付款失败，8：待退款，16：已退款，32：退款失败，64：订单异常，128：订单关闭
     */
    order_status: number;
    /**
     * 表示订单异常或失败时的异常信息
     */
    exection_msg?: string;
    /**
     * 对订单的描述
     */
    desc?: string;
    /**
     * 支付金额
     */
    fee?: number;
    /**
     * 付款成功时间
     */
    pay_success_time?: number;
    /**
     * 退款成功时间
     */
    refund_success_time?: number;
    /**
     * 记录更新时间
     */
    updated_at: number;
    /**
     * 记录创建时间
     */
    created_at: number;
};

export class PayOrder {
    /**
     * 订单总表
     */
    id!: number;
    /**
     * 支付用户
     */
    user_id!: number;
    /**
     * 支付平台：1：微信，2：支付宝，3：苹果
     */
    pay_platform!: PayPlatform;
    /**
     * 对应订单详情表的id
     */
    detail_order_id!: number;
    /**
     * 对应平台请求时的配置信息id
     */
    config_id?: number;
    /**
     * 对应平台的商家订单号
     */
    out_trade_no?: string;
    /**
     * 订单状态（二进制状态码），1：待付款，2：已付款，4：付款失败，8：待退款，16：已退款，32：退款失败，64：订单异常，128：订单关闭
     */
    order_status!: number;
    /**
     * 表示订单异常或失败时的异常信息
     */
    exection_msg?: string;
    /**
     * 对订单的描述
     */
    desc?: string;
    /**
     * 支付金额
     */
    fee?: number;
    /**
     * 付款成功时间
     */
    pay_success_time?: number;
    /**
     * 退款成功时间
     */
    refund_success_time?: number;
    /**
     * 记录更新时间
     */
    updated_at!: number;
    /**
     * 记录创建时间
     */
    created_at!: number;

    constructor(order: IPayOrder) {
        Object.assign(this, order);
    }

    get isPaying(): boolean {
        return (this.order_status & PayStatus.paying) > 0;
    }

    get isPaid(): boolean {
        return (this.order_status & PayStatus.paid) > 0;
    }

    get isPayFail(): boolean {
        return (this.order_status & PayStatus.fail) > 0;
    }

    get isException(): boolean {
        return (this.order_status & PayStatus.exception) > 0;
    }
}
